<template>
  <div class="mb-4">
    <button class="btn btn-info btn-icon mw mt-4" @click="sendRequest">
      {{ "create_query" | setText("Сформировать заявку") }}
    </button>
  </div>
</template>
<script>
import {
  logger,
  errorNotify,
  toFormData,
  dateConvert,
  addMonth,
} from "@/plugins/functions";

export default {
  methods: {
    async sendRequest() {
      this.$loading(true);
      const url = `${this.currentRequest.service.api_endpoint_url}contract`;
      const method = "post";
      const headers = {
        Authorization:
          "Basic " +
          btoa(
            this.currentRequest.service.api_login +
              ":" +
              this.currentRequest.service.api_password
          ),
      };
      //DATA
      let data = {
        applicant: {
          person: {
            passportData: {
              series: "AB",
              number: "1575591",
            },
            pinfl: "30507840230037",
          },
          organization: null,
          phone: "",
          address: "г. Ташкент, Янгихаётский район,",
          email: "",
        },
        owner: {
          person: null,
          organization: {
            inn: "307822300",
          },
          applicantIsOwner: false,
        },
        vehicle: {
          techPassportData: {
            series: "AAF",
            number: "4525260",
          },
          govNumber: "01F051UB",
        },
        drivers: [
          {
            passportData: {
              series: "AB",
              number: "1575591",
            },
            pinfl: "30507840230037",
          },
        ],
        details: {
          issueDate: "2022-06-12",
          startDate: "2022-06-12",
          endDate: "",
          specialNotes: "",
          insurerActivityType: "",
          driverNumberRestriction: false,
        },
        payment: {
          sumInsured: "40000000",
          discountId: "1",
          discount: "28000",
          useTerritoryId: "1",
          contractTermsConclusionId: "1",
          insurancePremium: "56000",
          insurancePremiumPaidToInsurer: "28000",
          commission: "10000",
          seasonalInsuranceId: "7",
        },
      };

      //REQUEST
      return this.$http({
        method: method,
        data: data,
        url: url,
        headers: headers,
      })
        .then((response) => {
          const responseData = response.data;

          if (responseData) {
            switch (responseData.result) {
              case 0:
                this.$emit("input", {
                  exchange_id: responseData.contract_id,
                  service_request: {
                    state: "sent",
                    service: "apex",
                    exchange_id: responseData.contract_id,
                    response: JSON.stringify(responseData),
                    body: JSON.stringify(data),
                  },
                });
                break;

              default:
                break;
            }

            if (responseData.result_message) {
              this.$notify({
                title: "APEX",
                message: responseData.result_message,
                icon: "ti-info",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            }
          }

          return responseData;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  props: ["value", "data", "currentRequest", "user_id"],
};
</script>
<style>
</style>
 